export default __webpack_public_path__ + "static/media/spells 7.ac341c5e.jpg";